import React, { Component, useEffect, useState } from "react";
import { useMutation, useQuery } from '@apollo/client';
import * as toxicity from '@tensorflow-models/toxicity';
import ToxicityGrid from './ToxicityGrid'; 
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import '../App.css';
import { ADD_POST, UPDATE_POST } from '../utils/mutations';
import Auth from '../utils/auth';
import { GET_ALL_POSTS } from '../utils/queries';
import UserBadge from "./UserBadge";

import postToGeoJSON from '../utils/postToGeoJSON';
// import { toxicity } from '@tensorflow-models/toxicity';
  // Post states.

// Toxicity filter based on https://medium.com/tensorflow/text-classification-using-tensorflow-js-an-example-of-detecting-offensive-language-in-browser-e2b94e3565ce
const Post = (props) => {

  // This is used for the state of the form
  let bodyValue;
  if (props.editPostBody) {
    bodyValue = props.editPostBody;
  } else {
    bodyValue = '';
  }
  const [formState, setFormState] = useState({ body: bodyValue });
  const [addPost, { error: addPostError }] = useMutation(ADD_POST);
  const [updatePost, { error: updatePostError }] = useMutation(UPDATE_POST);


  const [postText, setPostText] = useState(bodyValue);
  const [postValidationText, setPostValidationText] = useState();
  const [toxicityResult, setToxicityResult] = useState([]);
  const [spinnerHidden, setSpinnerHidden] = useState(true);
  const [postDisabled, setPostDisabled] = useState(false);
  const [postButtonText, setPostButtonText] = useState("Post");
  const [didPostSend, setDidPostSend] = useState(0);
  const [approvePost, setApprovePost] = useState(true);
  const [closeEnough, setCloseEnough] = useState(false);
  const [currentDistance, setCurrentDistance] = useState(0);
  const { loading, error, data, refetch } = useQuery(GET_ALL_POSTS);
  const [nearby, setNearby] = useState(false);
  const [userSolutionInput, setUserSolutionInput] = useState('');
  const [userSolutions, setUserSolutions] = useState([]);
  const [solutionStatus, setSolutionStatus] = useState('');
  const [ab604Features, setAb604Features] = useState([]);
  const [postingDistrict, setPostingDistrict] = useState(null);
  // This should probably be server side.
  const categories = require('../utils/categories.json');

  const isPointInRing = (point, ring) => {
    if (!Array.isArray(point) || !Array.isArray(ring) || ring.length < 3) return false;
    const x = Number(point[0]);
    const y = Number(point[1]);
    if (![x, y].every(Number.isFinite)) return false;

    let inside = false;
    for (let i = 0, j = ring.length - 1; i < ring.length; j = i, i += 1) {
      const xi = Number(ring[i]?.[0]);
      const yi = Number(ring[i]?.[1]);
      const xj = Number(ring[j]?.[0]);
      const yj = Number(ring[j]?.[1]);
      if (![xi, yi, xj, yj].every(Number.isFinite)) continue;

      const intersects =
        yi > y !== yj > y &&
        x < ((xj - xi) * (y - yi)) / ((yj - yi) || Number.EPSILON) + xi;

      if (intersects) inside = !inside;
    }

    return inside;
  };

  const isPointInPolygon = (point, polygonCoordinates) => {
    if (!Array.isArray(polygonCoordinates) || polygonCoordinates.length === 0) return false;
    const outerRing = polygonCoordinates[0];
    if (!isPointInRing(point, outerRing)) return false;

    for (let i = 1; i < polygonCoordinates.length; i += 1) {
      if (isPointInRing(point, polygonCoordinates[i])) return false;
    }

    return true;
  };

  const isPointInGeometry = (point, geometry) => {
    if (!geometry || typeof geometry !== 'object') return false;

    if (geometry.type === 'Polygon') {
      return isPointInPolygon(point, geometry.coordinates);
    }

    if (geometry.type === 'MultiPolygon' && Array.isArray(geometry.coordinates)) {
      return geometry.coordinates.some((polygonCoordinates) =>
        isPointInPolygon(point, polygonCoordinates)
      );
    }

    return false;
  };

  const checkPost = async (posts) => {
    if (postText.length !== 0) {

        // The minimum prediction confidence.
        const threshold = 0.2;

        // Which toxicity labels to return.
        const labelsToInclude = ['toxicity', 'severe_toxicity', 'identity_attack', 'insult', 'threat', 'sexual_explicit', 'obscene'];

        
        // setPostButtonText(" Checking post content...");

        const model = await toxicity.load(threshold, labelsToInclude);
        const predictions = await model.classify([postText]);
        // console.log(predictions);
        //predictions.forEach((prediction) => {
          // console.log(`${prediction.label}: ${prediction.results[0].match}, ${prediction.results[0].probabilities[1]}`);
        //});

        let isPostApproved = true;
        for (let prediction of predictions) {
            if (prediction.results[0].match === true) {
                isPostApproved = false;
                break;
            }
        }

        setApprovePost(isPostApproved);
        setPostButtonText("Post");

        if (isPostApproved) {
            console.log("Passed toxicity filter.");
        } else {
            console.log("Failed toxicity filter.");
        }

        return isPostApproved;
    }
    return false; // Default return in case postText.length is 0
}
useEffect(() => {
  const checkDistanceInKilometers = (centerLatitude, centerLongitude, currentLatitude, currentLongitude) => {
    return Math.acos(Math.sin(centerLatitude)*Math.sin(currentLatitude)+Math.cos(centerLatitude)*Math.cos(currentLatitude)*Math.cos(currentLongitude-centerLongitude))*63710
  }
  if (props.currentLatitude && props.currentLongitude) {
    let distance = checkDistanceInKilometers(props.centerLatitude, props.centerLongitude, props.currentLatitude, props.currentLongitude);
    setCurrentDistance(distance);
    // console.log(distance);
    if (distance <= 100) {
      setCloseEnough(true);
    } else {
      setCloseEnough(false);
    }
  }
}, [props.currentLatitude, props.currentLongitude, props.centerLatitude, props.centerLongitude]);

useEffect(() => {
  let isCancelled = false;

  const loadDistricts = async () => {
    try {
      const response = await fetch('/AB-604.geojson');
      if (!response.ok) return;

      const json = await response.json();
      if (!isCancelled) {
        setAb604Features(Array.isArray(json?.features) ? json.features : []);
      }
    } catch (error) {
      if (!isCancelled) setAb604Features([]);
    }
  };

  loadDistricts();
  return () => {
    isCancelled = true;
  };
}, []);

useEffect(() => {
  const lat = Number(props.centerLatitude);
  const lon = Number(props.centerLongitude);

  if (![lat, lon].every(Number.isFinite) || !Array.isArray(ab604Features) || !ab604Features.length) {
    setPostingDistrict(null);
    return;
  }

  const point = [lon, lat];
  const districtFeature = ab604Features.find((feature) =>
    isPointInGeometry(point, feature?.geometry)
  );

  const districtRaw = districtFeature?.properties?.DISTRICT;
  if (districtRaw == null) {
    setPostingDistrict(null);
    return;
  }

  const districtNum = Number.parseInt(String(districtRaw), 10);
  setPostingDistrict(Number.isFinite(districtNum) ? districtNum : districtRaw);
}, [props.centerLatitude, props.centerLongitude, ab604Features]);
 
  
  // update state based on form input changes
  const handleChange = (event) => {
    const { name, value } = event.target;
    // console.log(name, value);

    setFormState({
      ...formState,
      [name]: value,
    });
  };

  useEffect(() => {
    handleChange({ target: { name: "body", value: postText } });
  }, [postText]);

  const addUserSolution = () => {
    const trimmed = String(userSolutionInput || '').trim();
    if (!trimmed) {
      setSolutionStatus('Enter solution text before adding.');
      return;
    }
    setUserSolutions((prev) => [...prev, trimmed]);
    setUserSolutionInput('');
    setSolutionStatus('Solution added.');
  };

  const removeUserSolution = (index) => {
    setUserSolutions((prev) => prev.filter((_, i) => i !== index));
  };

  const handleFormSubmit = async (event) => {
    if (postText.length !== 0) {
      event.preventDefault();
      try {
        setSpinnerHidden(false);
        setPostButtonText("Checking post content...");
        // let approvePost = await checkPost();
        // console.log(approvePost);
        // if (approvePost === true) {
        if (true) {
          let mutationResponse;
          if (props.update === true) {
            mutationResponse = updatePost({
              variables: {userId: props.editUser, postId: props.editPostId, body: formState.body, userSolutions},
            });
          } else {
            mutationResponse = addPost({
              variables: {body: formState.body, latitude: props.centerLatitude, longitude: props.centerLongitude, nearby, userSolutions},
            });
            props.setPostSnackbarOpen(true);
            props.setIncomingPost(formState.body)
          }
          // window.location.reload();
          // console.log(mutationResponse);
        }
        // set to change
        setPostDisabled(false);
        setSpinnerHidden(true);
        setPostButtonText("Posted!");
        props.setIsPostPaneOpen(false);
      } catch (e) {
        console.log(e);
      }
    } else {
      event.preventDefault();
      setPostValidationText("Post cannot be empty.");
    } 
  };

    return ( 
          <>{props.editPostId}
          <div className="flex justify-center text-xl m-4 align-items-center justify-content-center text-center">Report</div>
          {/* <div className="flex justify-center text-l m-4">Choose from the following examples or write your own:</div> */}
          {/* <select className="p-2 m-2" onChange={(e) => {
              setPostText(e.target.value);
              document.querySelector('.post-textarea').value = e.target.value;
            }}>
              <option value="">Choose an example</option>
              {categories.map((category, index) => {
                return <option key={index} value={category}>{category}</option>
              }
              )}
          </select> */}
          <form className="w-full align-items-center justify-content-center text-center max-w-5xl" onSubmit={handleFormSubmit}>
            <div className="flex justify-center">
              <UserBadge></UserBadge>
            </div>
            <div className="mt-1 text-xs text-gray-300">
              {postingDistrict ? `Posting in CA-${postingDistrict}` : 'Posting district unavailable'}
            </div>
            <textarea
              className="m-2 p-2 post-textarea"
              value={postText}
              placeholder="What are you reporting?"
              name="body"
              maxLength={128}
              onChange={(e) => {
                setPostText(e.target.value);
                handleChange(e);
              }}
              rows="6"
              columns="128"
            />
            <br/>
            <p>{128 - postText.length} letters left.</p>
            <div className="mt-3">
              <div className="text-xs font-semibold text-gray-100 mb-2 justify-center">User Solutions</div>
              <div className="flex w-[90%] mx-auto flex-row items-center gap-2 justify-center">
                <input
                  className="w-[90%] rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-200"
                  placeholder="Add a solution"
                  type="text"
                  value={userSolutionInput}
                  onChange={(e) => {
                    const value = e.target.value;
                    setUserSolutionInput(value);
                    if (String(value).trim()) {
                      setSolutionStatus('Not added yet. Click Add to commit this solution.');
                    } else {
                      setSolutionStatus('');
                    }
                  }}
                />
                <button
                  type="button"
                  className="btn-active"
                  onClick={addUserSolution}
                >
                  Add
                </button>
              </div>
              {!!solutionStatus && (
                <div className="mt-1 text-center text-xs text-gray-500">{solutionStatus}</div>
              )}
              {userSolutions.length > 0 && (
                <div className="mt-2 w-[85%] mx-auto space-y-2">
                  {userSolutions.map((solution, index) => (
                    <span key={`${solution}-${index}`} className="btn-active flex w-full items-center justify-between gap-2 text-white">
                      <span className="min-w-0 flex-1 text-left break-words">{solution}</span>
                      <button
                        type="button"
                        className="term-remove shrink-0"
                        aria-label={`Remove solution ${index + 1}`}
                        onClick={() => removeUserSolution(index)}
                      >
                        x
                      </button>
                    </span>
                  ))}
                </div>
              )}
            </div>
            <div>

            <p className="fs-7 m-2">Current Post @ {`${props.centerLatitude.toFixed(5)}, ${props.centerLongitude.toFixed(5)}`}
            {props.currentLatitude && props.currentLongitude && closeEnough &&
                <div className="fs-7">
                <p>
                  <input id="nearby" className="checkbox" type="checkbox" onChange={() => {
                    setNearby(!nearby);
                  }}/> <span className="material-symbols-outlined">
                  how_to_reg
                  </span>{currentDistance.toFixed(0)} meters from point; show nearby badge? 
                </p>
                Current @ {`${props.currentLatitude}, ${props.currentLongitude}`}
                </div>
            }
            </p>
            </div>
            <span className="text-red-800">{postValidationText}</span>
            
            <div>
              <Button className="btn-active" type="submit" variant="flat" disabled={postDisabled}>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="false"
                hidden={spinnerHidden}
              />{postButtonText}
              </Button>
            </div>
          </form>
          <br/>
          </>
          )
}

export default Post;
